<template>
  <el-dialog
    class="rc-dialog"
    title="题库列表"
    width="60%"
    :visible.sync="dialogVisible"
    v-if="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
    @close="closeDialog"
  >
    <div>
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="(item, index) in themeList"
          :key="item + index"
          :label="item"
        ></el-checkbox>
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="importQuestions"
        >导入</el-button
      >
      <el-button @click="closeDialog" size="small">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import vue from "../../../main";
import { getThemeList } from "@/api/examQuestion";
export default {
  props: {
    defaultKeys: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    defaultKeys(val) {
      this.checkList = val;
    }
  },
  data() {
    return {
      dialogVisible: false,
      themeList: [],
      themeInfo: {},
      checkList: this.defaultKeys
    };
  },
  created() {
    vue.$on("importQuestion", () => {
      this.dialogVisible = true;
      getThemeList().then(res => {
        if (!res || res.code != 0) return;
        for (const key in res.data) {
          this.themeList.push(key);
        }
        this.themeInfo = res.data;
      });
    });
  },
  methods: {
    importQuestions() {
      let questions = [];
      this.checkList.forEach(ele => {
        questions = questions.concat(this.themeInfo[ele]);
      });
      this.closeDialog();
      this.$emit("questionList", [questions, this.checkList]);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.themeList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox {
  display: block;
  margin-bottom: 15px;
}
</style>
